import { postProductCheck, } from "@erp/shared/api/generated/wrappers/product";
import { useInvalidateQueries, useState } from "@erp/shared/composables";
import { queries } from "@erp/shared/queries";
import { isValidId } from "@erp/shared/utils/https/is-valid-id";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed, inject, provide } from "vue";
export const useStockCheckAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const [spotId, setSpotId] = useState(null);
    const readStockCheckQueryOptions = computed(() => {
        return {
            ...queries.stock.bySpot(spotId.value ?? 0),
            enabled: computed(() => !!spotId.value),
        };
    });
    const readStockCheck = useQuery(readStockCheckQueryOptions);
    const createStockCheck = useMutation({
        mutationFn: async ({ body }) => {
            if (!isValidId(spotId.value)) {
                throw new Error("유효하지 않은 위치 ID입니다.");
            }
            const response = await postProductCheck(spotId.value, body);
            return response;
        },
        onSuccess: () => {
            invalidateQueries([queries.stock._def]);
        },
    });
    return {
        readStockCheck,
        createStockCheck,
        setSpotId,
        spotId,
    };
};
const STOCK_CHECK_KEY = Symbol("stockCheck");
export const provideStockCheck = () => {
    const action = useStockCheckAction();
    const [selectedSpotName, setSelectedSpotName] = useState(null);
    const ctx = {
        ...action,
        selectedSpotName,
        setSelectedSpotName,
    };
    provide(STOCK_CHECK_KEY, ctx);
    return ctx;
};
export const injectStockCheck = () => {
    const ctx = inject(STOCK_CHECK_KEY);
    if (!ctx)
        throw new Error("provideStockCheck()를 먼저 호출하세요.");
    return ctx;
};
